export class SKPaymentDiscount {
    constructor(identifier, keyIdentifier, nonce, signature, timestamp) {
        this.identifier = identifier;
        this.keyIdentifier = keyIdentifier;
        this.nonce = nonce;
        this.signature = signature;
        this.timestamp = timestamp;
    }
}
//# sourceMappingURL=SKPaymentDiscount.js.map